import { Attributes, Misc, NeoModel, Rules, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class UnrecognisedImportFilesReportCriteria extends ValueObject  
{
    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public reportingDate: Date | null = null;
}